"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var SasWaterQuality_exports = {};
__export(SasWaterQuality_exports, {
  SasWaterQuality: () => SasWaterQuality
});
module.exports = __toCommonJS(SasWaterQuality_exports);
var import_topo_map = require("@cartographerio/topo-map");
var import_inventory_enums = require("@cartographerio/inventory-enums");
var import_core = require("../../core/index.js");
const SasWaterQuality = (0, import_core.mapSchemaWithDefaults)({
  mapId: (0, import_topo_map.unsafeMapId)("SasWaterQuality"),
  title: "Coliforms",
  layers: [
    (0, import_topo_map.pointLayer)({
      layerId: (0, import_topo_map.unsafeMapLayerId)("SasWaterQuality"),
      title: "Coliforms",
      source: (0, import_core.cartographerSourceWithDefaults)({
        layerId: (0, import_topo_map.unsafeMapLayerId)("SasWaterQuality"),
        attribution: []
      }),
      defaultAttribute: "site",
      defaultZOrder: "timestamp",
      attributes: [
        (0, import_topo_map.attributeGroup)({
          label: "Location",
          attributes: [
            (0, import_topo_map.stringAttr)({
              attributeId: "river",
              label: "River",
              buckets: "auto"
            }),
            (0, import_topo_map.stringAttr)({ attributeId: "site", label: "Site", buckets: "auto" }),
            (0, import_topo_map.enumAttr)({
              attributeId: "siteType",
              label: "Site Type",
              enum: import_inventory_enums.SasWaterQualitySiteTypeEnum,
              markers: {
                Downstream: import_topo_map.marker.fromColor("#27b6f3"),
                Upstream: import_topo_map.marker.fromColor("#27bf57")
              }
            })
          ]
        }),
        (0, import_topo_map.attributeGroup)({
          label: "Survey",
          attributes: [
            (0, import_topo_map.surveyAttr)("surveyId", "Survey"),
            (0, import_topo_map.timestampAttr)({
              attributeId: "timestamp",
              label: "Date/Time",
              buckets: "auto"
            }),
            (0, import_topo_map.attachmentAttr)("photographs", "Photographs")
          ]
        }),
        (0, import_topo_map.attributeGroup)({
          label: "Lab Results",
          attributes: [
            (0, import_topo_map.thresholdAttr)({
              attributeId: "escherichiaColi",
              label: "Escherichia Coli",
              unit: "CFU/100ml",
              buckets: [
                (0, import_topo_map.thresholdBucket)(0, import_topo_map.marker.quality(1)),
                (0, import_topo_map.thresholdBucket)(200, import_topo_map.marker.quality(0.8)),
                (0, import_topo_map.thresholdBucket)(400, import_topo_map.marker.quality(0.6)),
                (0, import_topo_map.thresholdBucket)(600, import_topo_map.marker.quality(0.4)),
                (0, import_topo_map.thresholdBucket)(800, import_topo_map.marker.quality(0.2)),
                (0, import_topo_map.thresholdBucket)(1e3, import_topo_map.marker.quality(0))
              ],
              decimalPlaces: 0
            }),
            (0, import_topo_map.thresholdAttr)({
              attributeId: "totalThermotolerantColiforms",
              label: "Total Thermotolerant Coliforms",
              unit: "CFU/100ml",
              buckets: [
                (0, import_topo_map.thresholdBucket)(0, import_topo_map.marker.quality(1)),
                (0, import_topo_map.thresholdBucket)(200, import_topo_map.marker.quality(0.8)),
                (0, import_topo_map.thresholdBucket)(400, import_topo_map.marker.quality(0.6)),
                (0, import_topo_map.thresholdBucket)(600, import_topo_map.marker.quality(0.4)),
                (0, import_topo_map.thresholdBucket)(800, import_topo_map.marker.quality(0.2)),
                (0, import_topo_map.thresholdBucket)(1e3, import_topo_map.marker.quality(0))
              ],
              decimalPlaces: 0
            }),
            (0, import_topo_map.thresholdAttr)({
              attributeId: "intestinalEnterococci",
              label: "Intestinal Enterococci",
              unit: "CFU/100ml",
              buckets: [
                (0, import_topo_map.thresholdBucket)(0, import_topo_map.marker.quality(1)),
                (0, import_topo_map.thresholdBucket)(200, import_topo_map.marker.quality(0.8)),
                (0, import_topo_map.thresholdBucket)(400, import_topo_map.marker.quality(0.6)),
                (0, import_topo_map.thresholdBucket)(600, import_topo_map.marker.quality(0.4)),
                (0, import_topo_map.thresholdBucket)(800, import_topo_map.marker.quality(0.2)),
                (0, import_topo_map.thresholdBucket)(1e3, import_topo_map.marker.quality(0))
              ],
              decimalPlaces: 0
            })
          ]
        }),
        (0, import_topo_map.attributeGroup)({
          label: "Field Observations",
          attributes: [
            (0, import_topo_map.numberAttr)({
              attributeId: "numberOfSwimmers",
              label: "Number of Swimmers",
              buckets: "auto",
              decimalPlaces: 0
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "numberOfOtherWaterUsers",
              label: "Number of Other Water Users",
              buckets: "auto",
              decimalPlaces: 0
            }),
            (0, import_topo_map.enumAttr)({
              attributeId: "weather",
              label: "Weather",
              enum: import_inventory_enums.SasWaterQualityWeatherEnum
            }),
            (0, import_topo_map.numberAttr)({
              attributeId: "airTemperature",
              label: "Air Temperature",
              unit: "\xB0C",
              buckets: [
                (0, import_topo_map.rangeBucket)(null, 0, import_topo_map.marker.hue(240)),
                (0, import_topo_map.rangeBucket)(0, 5, import_topo_map.marker.hue(210)),
                (0, import_topo_map.rangeBucket)(5, 10, import_topo_map.marker.hue(180)),
                (0, import_topo_map.rangeBucket)(10, 15, import_topo_map.marker.hue(150)),
                (0, import_topo_map.rangeBucket)(15, 20, import_topo_map.marker.hue(120)),
                (0, import_topo_map.rangeBucket)(20, 25, import_topo_map.marker.hue(90)),
                (0, import_topo_map.rangeBucket)(25, 30, import_topo_map.marker.hue(60)),
                (0, import_topo_map.rangeBucket)(30, 35, import_topo_map.marker.hue(30)),
                (0, import_topo_map.rangeBucket)(35, null, import_topo_map.marker.hue(0))
              ],
              decimalPlaces: 0
            })
          ]
        })
      ]
    })
  ]
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  SasWaterQuality
});
//# sourceMappingURL=SasWaterQuality.js.map
